// Reinitialize JavaScript components after Turbo Stream updates
document.addEventListener('turbo:frame-load', reinitializeComponents);
document.addEventListener('turbo:before-stream-render', reinitializeComponents);

// Also reinitialize on regular page loads
document.addEventListener('turbo:load', reinitializeComponents);
document.addEventListener('DOMContentLoaded', reinitializeComponents);

// The key event: after any turbo stream renders
document.addEventListener('turbo:submit-end', function(event) {
  // Small delay to ensure DOM is updated
  setTimeout(reinitializeComponents, 50);
});

// Listen for all turbo stream render events
document.addEventListener('turbo:before-stream-render', function(event) {
  // Queue reinitialization after the stream renders
  setTimeout(reinitializeComponents, 100);
});

function reinitializeComponents() {
  console.log('Reinitializing components after Turbo update');
  
  try {
    // Initialize Flowbite components
    initializeFlowbite();
    
    // Reinitialize Stimulus controllers 
    reinitializeStimulus();
    
    // Reinitialize custom toast functionality
    if (typeof window.initializeToasts === 'function') {
      window.initializeToasts();
    }
    
    // Reinitialize any other custom JavaScript components
    initializeCustomComponents();
    
  } catch (error) {
    console.error('Error reinitializing components:', error);
    // Still try manual fallback if Flowbite fails
    console.log('Falling back to manual initialization due to error');
    initializeFlowbiteManually();
  }
}

function initializeFlowbite() {
  console.log('Initializing Flowbite components');
  
  try {
    // Flowbite 3 - try the main initialization methods
    if (typeof window.Flowbite !== 'undefined') {
      
      // Try the global init method first (most common)
      if (typeof window.Flowbite.init === 'function') {
        console.log('Using Flowbite.init()');
        window.Flowbite.init();
        return;
      }
      
      // Try initAll method
      if (typeof window.Flowbite.initAll === 'function') {
        console.log('Using Flowbite.initAll()');
        window.Flowbite.initAll();
        return;
      }
      
      // Try individual component initialization
      const components = [
        'Dropdowns', 'Modals', 'Accordions', 'Collapses', 
        'Dismisses', 'Drawers', 'Popovers', 'Tabs', 'Tooltips',
        'Carousel', 'Datepicker', 'Dial'
      ];
      
      let initializedCount = 0;
      components.forEach(component => {
        try {
          if (window.Flowbite[component]) {
            if (typeof window.Flowbite[component].initAll === 'function') {
              console.log(`Initializing Flowbite ${component}`);
              window.Flowbite[component].initAll();
              initializedCount++;
            } else if (typeof window.Flowbite[component].init === 'function') {
              console.log(`Initializing Flowbite ${component} (using init)`);
              window.Flowbite[component].init();
              initializedCount++;
            }
          }
        } catch (componentError) {
          console.warn(`Failed to initialize Flowbite ${component}:`, componentError);
        }
      });
      
      if (initializedCount > 0) {
        console.log(`Successfully initialized ${initializedCount} Flowbite components`);
        return;
      }
    }
    
    // Try global initFlowbite function (for older versions)
    if (typeof window.initFlowbite === 'function') {
      console.log('Using global initFlowbite function');
      window.initFlowbite();
      return;
    }
    
    // If nothing else works, fall back to manual initialization
    console.log('No Flowbite initialization methods found, using manual fallback');
    initializeFlowbiteManually();
    
  } catch (error) {
    console.error('Error in Flowbite initialization:', error);
    console.log('Falling back to manual initialization');
    initializeFlowbiteManually();
  }
}

function initializeFlowbiteManually() {
  console.log('Manual Flowbite initialization starting...');
  
  // Manual dropdown initialization (Flowbite style)
  const dropdownElements = document.querySelectorAll('[data-dropdown-toggle]');
  console.log(`Found ${dropdownElements.length} dropdown elements`);
  
  dropdownElements.forEach(element => {
    if (!element.hasAttribute('data-dropdown-initialized')) {
      element.setAttribute('data-dropdown-initialized', 'true');
      const targetId = element.getAttribute('data-dropdown-toggle');
      const target = document.getElementById(targetId);
      
      if (target) {
        console.log(`Initializing dropdown for ${targetId}`);
        element.addEventListener('click', function(e) {
          e.preventDefault();
          target.classList.toggle('hidden');
        });
        
        // Close on outside click
        document.addEventListener('click', function(e) {
          if (!element.contains(e.target) && !target.contains(e.target)) {
            target.classList.add('hidden');
          }
        });
      }
    }
  });
  
  // Manual modal initialization
  const modalElements = document.querySelectorAll('[data-modal-toggle]');
  console.log(`Found ${modalElements.length} modal elements`);
  
  modalElements.forEach(element => {
    if (!element.hasAttribute('data-modal-initialized')) {
      element.setAttribute('data-modal-initialized', 'true');
      const targetId = element.getAttribute('data-modal-toggle');
      const target = document.getElementById(targetId);
      
      if (target) {
        console.log(`Initializing modal for ${targetId}`);
        element.addEventListener('click', function(e) {
          e.preventDefault();
          target.classList.toggle('hidden');
        });
      }
    }
  });
  
  // Manual close buttons for modals
  const modalCloseElements = document.querySelectorAll('[data-modal-hide]');
  modalCloseElements.forEach(element => {
    if (!element.hasAttribute('data-modal-close-initialized')) {
      element.setAttribute('data-modal-close-initialized', 'true');
      const targetId = element.getAttribute('data-modal-hide');
      const target = document.getElementById(targetId);
      
      if (target) {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          target.classList.add('hidden');
        });
      }
    }
  });
}

function reinitializeStimulus() {
  try {
    if (window.Stimulus && window.Stimulus.application) {
      console.log('Reinitializing Stimulus controllers');
      
      // Force Stimulus to reprocess the entire document
      window.Stimulus.application.stop();
      window.Stimulus.application.start();
    }
  } catch (error) {
    console.error('Error reinitializing Stimulus:', error);
  }
}

function initializeCustomComponents() {
  // Add any custom component initialization here
  
  // Example: Reinitialize custom dropdowns, modals, etc.
  const customDropdowns = document.querySelectorAll('.custom-dropdown');
  customDropdowns.forEach(dropdown => {
    if (!dropdown.hasAttribute('data-custom-initialized')) {
      dropdown.setAttribute('data-custom-initialized', 'true');
      // Add your custom initialization logic here
    }
  });
}

// Export for use in other files if needed
window.reinitializeComponents = reinitializeComponents;